<template>
    <div>
        <app-header></app-header>
        <div class="grid-container">
            <div class="grid-x grid-padding-x pad-top">
                <div class="cell small-12 medium-10 medium-offset-1">
                    <!--
                    <div class="search-bar">
                        <div class="grid-x grid-padding-x">
                            <div class="cell small-12 medium-4">
                                <form v-on:submit="submitSearch">
                                    <input
                                        class="product-search"
                                        placeholder="Search and hit enter"
                                        v-model="searchTerm"
                                        type="text" />
                                </form>
                            </div>
                        </div>
                    </div>
                    -->
                    <div
                        v-if="message.length > 0"
                        class="clear grid-x grid-padding-x">
                        <div class="cell small-12">
                            <h2>{{ message }}</h2>
                        </div>
                    </div>
                    <div class="clear grid-x grid-margin-x">
                        <div
                            v-for="(garment, index) in garments"
                            v-if="garment.garment_colours[0]"
                            v-bind:key="index"
                            class="cell small-6 medium-4 garment-card marg-bottom--small pad--xs relative">
                            <span
                                v-if="isAuthenticated === true"
                                v-on:click="addFavourite(garment.id)"
                                class="favourite">
                                <img src="../../../static/images/filter-garments/favourite.png" alt="" />
                            </span>
                            <router-link
                                v-bind:to="`/${garment.category.slug}/${garment.product_code}/${garment.slug}`">
                                <div class="small-pad--small medium-pad--large">
                                    <img
                                        v-bind:src="`https://our-catalogue.com/RUNS/images/${garment.product_code}.jpg?width=300`"
                                        v-bind:alt="garment.img_alt_tag" />
                                </div>
                                <h5 class="text-blue" v-if="garment.featured_garment !== 'false'">
                                    {{ garment.featured_garment }}
                                </h5>
                                <p class="small">
                                    {{ garment.product_code }}<br />
                                    {{ garment.name }}<br />
                                    Price from:
                                    <span class="text-light-blue">
                                        £{{ (((garment.garment_colours[0].garment_colour_sizes[0].price*21)/100)+garment.garment_colours[0].garment_colour_sizes[0].price) | numeral('0,0.00') }}
                                    </span>
                                </p>
                                <p class="add-to-basket">
                                    <img
                                        width="55"
                                        src="../../../static/images/filter-garments/add-to-basket.png"
                                        alt="" />
                                </p>
                            </router-link>
                        </div>
                    </div>
                    <div v-if="sector !== false" class="clear grid-x grid-padding-x">
                        <div class="cell small-12 pad-top pad-bottom">
                            <h1>{{ sector.h1 }}</h1>
                            <div v-html="sector.content"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import axios from '../../axios';

export default {
    name: 'Sectors',
    metaInfo() {
        return {
            title: this.metaTitle,
            titleTemplate: '%s-CustomisedClothing',
            meta: [
                { description: this.metaDescription },
            ],
            link: [
                { rel: 'canonical', href: `https://customisedclothing.com/garments/${this.sector.slug}` },
            ],

        };
    },
    computed: {
        metaTitle() {
            let title = 'Garments';
            if (this.sector !== false && this.sector.meta_title) {
                title = this.sector.meta_title;
            }
            return title;
        },
        metaDescription() {
            let description = 'Sectors';
            if (this.sector !== false && this.sector.meta_description) {
                description = this.sector.meta_description;
            }
            return description;
        },
        isAuthenticated() {
            return this.$store.getters.isAuthenticated;
        },
        authData() {
            return this.$store.getters.authData;
        },
    },
    data() {
        return {
            garments: [],
            garment: {},
            loading: false,
            allLoaded: false,
            singleGarment: false,
            activeColour: false,
            basketItems: [],
            nextButtons: false,
            searchTerm: '',
            colours: [],
            message: '',
            selectGenderFilter: 'all',
            selectTypeFilter: 'all',
            selectBrandFilter: 'all',
            selectOrderPrice: 'all',
            featuredLoaded: false,
            category: false,
            sector: false,
        };
    },
    components: {
        VueSlider,
        appHeader: Header,
        appFooter: Footer,
    },
    methods: {
        getSector() {
            if (this.featuredLoaded === false) {
                this.featuredLoaded = true;
                this.message = '';
                const payload = {};
                payload.offset = this.offset;
                payload.filters = this.filters;
                payload.featured = true;
                this.category = false;
                const sector = this.$route.params.sector;
                axios.post(`/Garments/fetchSector.json?sector=${sector}`, payload)
                    .then((response) => {
                        this.sector = response.data.sector;
                        this.garments = this.sector.garments;
                    });
            }
        },
    },
    mounted() {
        this.getSector();
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Garments/Sectors.vue